import React, { createContext, useEffect, useState } from 'react';
import * as THREE from "three";

export  const ThreeContext = createContext();

export const Context = ({ children }) => {

    const [debug, setDebug] = useState(false);  
    const [perf, setPerf] = useState(false);  

    const Glass = new THREE.MeshStandardMaterial({ transparent : true, color: "#000000", opacity : 0.8, metalness : 0.8, roughness : 0.05, envMapIntensity : 1 })
    const Metal = new THREE.MeshStandardMaterial({ color: "#aaaaaa", metalness : 0.8, roughness : 0.1, envMapIntensity : 1});
    const BlackMetal = new THREE.MeshStandardMaterial({ color: "#111111", metalness : 0.8, roughness : 0.1, envMapIntensity : 1});
    const YellowMetal = new THREE.MeshStandardMaterial({ color: "#ffcc00", metalness : 0.8, roughness : 0.1, envMapIntensity : 1});
    const BlackPlastic = new THREE.MeshStandardMaterial({ color: "#222222", metalness : 0, roughness : 1, envMapIntensity : 0});
    const RedLight = new THREE.MeshStandardMaterial({ color: "#ff0000", metalness : 0, roughness : 1, envMapIntensity : 0, transparent : true, opacity : 0.8});
    const WhitePlastic = new THREE.MeshStandardMaterial({ color: "#ffffff", metalness : 0, roughness : 1, envMapIntensity : 0});
    const RedPlastic = new THREE.MeshStandardMaterial({ color: "#ff0000", metalness : 0, roughness : 1, envMapIntensity : 0});
    const GreyPlastic = new THREE.MeshStandardMaterial({ color: "#444444", metalness : 0, roughness : 1, envMapIntensity : 0});

    useEffect(() => {
        window.location.hash == "#debug" ? setDebug(true) : setDebug(false);
        window.location.hash == "#perf" ? setPerf(true) : setPerf(false);
    },[])

    return (
      <ThreeContext.Provider value={{debug, setDebug, perf, Glass, Metal, BlackMetal, BlackPlastic, RedLight, WhitePlastic, RedPlastic, GreyPlastic, YellowMetal}}>
        {children}
      </ThreeContext.Provider>
    );
}